import cert1 from "../assets/certificateAssets/image.png"
import cert2 from "../assets/certificateAssets/usmscc.jfif"
import cert3 from "../assets/certificateAssets/rrcacc.png"

export const certificates = [
    {
        name: "USAT Certified Triathlon Coach",
        image: cert1
    },
    {
        name: "USAT Polarized Certified Coach",
        image: cert1
    },
    {
        name: "RRCA Certified Run Coach",
        image: cert3
    },
    {
        name: "USAT Short Course Certified Coach",
        image: cert1
    },
    {
        name: "U.S. Masters Swim Coach",
        image: cert2
    },
]